import { EntityMetadataMap } from '@ngrx/data';

export const notificationEntityMetadataMap: EntityMetadataMap = {
  NotificationMethod: {},
};
